import { render, staticRenderFns } from "./hero-container.vue?vue&type=template&id=1b605cc4&"
import script from "./hero-container.vue?vue&type=script&lang=js&"
export * from "./hero-container.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports